import styled from 'styled-components';

import { Monospace2, WebLink, spacing, Body2 } from 'ui/theme';
import { OpenNewWindow24 } from 'ui/icons';
import { pxToRem } from 'utils/convert';

export const Code = styled(Monospace2)`
  font-size: ${pxToRem(13)};
`;

export const Body = styled(Body2)`
  display: inline-flex;
  align-items: center;
  margin-bottom: ${spacing.half};
`;

export const Link = styled(WebLink)`
  font-size: ${pxToRem(14)};
  margin: 0 ${spacing.quarter} ${spacing.base} ${spacing.quarter};
  display: inline-flex;
  align-items: center;
`;

export const OpenNewWindowIcon = styled(OpenNewWindow24)`
  display: inline-block;
  margin-left: ${spacing.quarter};
`;
